import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionAddMoreAndSaveMore = ({
    cartId,
    couponCode,
    isCouponWidget,
    couponSavings,
    amountToAdd,
    impressionEvent,
}: {
    cartId: string | number;
    couponCode: string;
    isCouponWidget: boolean;
    couponSavings: string;
    amountToAdd: string;
    impressionEvent: AnalyticsContextValue["impressionEvent"];
}) => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ADD_ITEM_SAVE_MORE,
        label: String(couponCode),
        context: JSON.stringify({
            save: couponSavings,
            add: amountToAdd,
            unlockCoupon: isCouponWidget,
            cartId: cartId,
        }),
    });
};

export const clickAddMoreAndSaveMore = ({
    cartId,
    couponCode,
    isCouponWidget,
    couponSavings,
    amountToAdd,
    clickEvent,
}: {
    cartId: string | number;
    couponCode: string;
    isCouponWidget: boolean;
    couponSavings: string;
    amountToAdd: string;
    clickEvent: AnalyticsContextValue["clickEvent"];
}) => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADD_ITEM_SAVE_MORE,
        label: String(couponCode),
        context: JSON.stringify({
            save: couponSavings,
            add: amountToAdd,
            unlockCoupon: isCouponWidget,
            cartId: cartId,
        }),
    });
};
